// So tien tu API ve BigInt ma khong nem loi: BigInt(undefined), BigInt(NaN), BigInt('12.5') nem va lam trang ca
// trang CMS. Phan le bi bo (tien la so nguyen); gia tri khong doc duoc = null, noi goi tu hien.
export function soNguyen(v: unknown): bigint | null {
  if (typeof v === 'bigint') return v;
  if (typeof v === 'number') return Number.isFinite(v) ? BigInt(Math.trunc(v)) : null;
  if (typeof v === 'string') {
    const m = /^\s*(-?\d+)(?:\.\d*)?\s*$/.exec(v);
    return m ? BigInt(m[1]!) : null;
  }
  return null;
}
